import z from "zod/v4";

import { UserInputSchema } from "../../../schemas/ai";

export const ContinueWorkflowPathParamDtoSchema = z.object({
  sessionId: z.uuid(),
});
export type ContinueWorkflowPathParamDto = z.infer<
  typeof ContinueWorkflowPathParamDtoSchema
>;

export const ContinueWorkflowRequestBodyDtoSchema = z.object({
  input: UserInputSchema.array(),
});

export type ContinueWorkflowRequestBodyDto = z.infer<
  typeof ContinueWorkflowRequestBodyDtoSchema
>;
